export const allFeatures = [
  "WEBSITE / Liên hệ khách hàng",
  "WEBSITE / Quản lý bài viết",
  "NGƯỜI DÙNG / Khách hàng",
  "NGƯỜI DÙNG / Khách hàng / Không mã",
  "NGƯỜI DÙNG / Khách hàng / Có mã",
  "NGƯỜI DÙNG / Khách hàng / Khách hàng",
  "NGƯỜI DÙNG / Khách hàng / ZTO-KH",
  "NGƯỜI DÙNG / Khách hàng / ZTO-VN",
  "NGƯỜI DÙNG / Khách hàng / ZTO-DL",
  "NGƯỜI DÙNG / Khách hàng / ZTO-VH",
  "NGƯỜI DÙNG / Khách hàng / ZTO-MH",
  "NGƯỜI DÙNG / Đối tác",
  "NGƯỜI DÙNG / Danh sách users",
  "NGƯỜI DÙNG / Phân quyền",
  "SẢN PHẨM / Sản phẩm cá nhân",
  "SẢN PHẨM / Sản phẩm dùng chung",
  "SẢN PHẨM / Xuất file excel",
  "SẢN PHẨM / Danh mục",
  "SẢN PHẨM / Nhà cung cấp",
  "SẢN PHẨM / Đánh giá - bình luận",
  "ĐƠN HÀNG",
  "ĐƠN HÀNG / Đơn thường",
  "ĐƠN HÀNG / Đơn VAT",
  "ĐƠN HÀNG / Xuất BG MH thường",
  "ĐƠN HÀNG / Xuất BG MH VAT",
  "ĐƠN HÀNG / Xuất hồ sơ thường",
  "ĐƠN HÀNG / Xuất hồ sơ VAT",
  "ĐƠN HÀNG / Xuất đối soát VAT nháp",
  "ĐƠN HÀNG / Báo giá vận chuyển thường",
  "ĐƠN HÀNG / Báo giá vận chuyển VAT",
  "ĐƠN HÀNG / Lưu trình",
  "ĐƠN HÀNG / Đối soát khách hàng",
  "ĐƠN HÀNG / Đối soát đối tác",
  "ĐƠN HÀNG / Khóa đơn hàng",
  "ĐƠN HÀNG / Cập nhật mã bao",
  "ĐƠN HÀNG / Tính toán lại chi phí",
  "ĐƠN HÀNG / Mua hộ",
  "ĐƠN HÀNG / Đơn hàng mua hộ / Đơn thường",
  "ĐƠN HÀNG / Đơn hàng mua hộ / Đơn VAT",
  "ĐƠN HÀNG / Mã bao",
  "ĐƠN HÀNG / Mã vận đơn TQ",
  "ĐƠN HÀNG / Mã vận đơn VN",
  "ĐƠN HÀNG / Đối soát KH",
  "ĐƠN HÀNG / Mã ĐT",
  "ĐƠN HÀNG / Đối soát ĐT",
  "ĐƠN HÀNG / Lợi nhuận",
  // Thứ tự nhóm trong màn phân quyền theo thứ tự ở đây: Kho vận ngay dưới Đơn hàng.
  "KHO VẬN / Quét nhập kho VN",
  "KHO VẬN / Quét xuất kho VN",
  "KHO VẬN / Đơn vô chủ",
  "ĐỐI SOÁT / Khách hàng thường",
  "ĐỐI SOÁT / Khách hàng VAT",
  "ĐỐI SOÁT / Đối tác thường",
  "ĐỐI SOÁT / Đối tác VAT",
  "KẾ TOÁN / Báo cáo / Doanh thu",
  "KẾ TOÁN / Báo cáo / Chi phí",
  "KẾ TOÁN / Báo cáo / Lợi nhuận",
  "KẾ TOÁN / Báo cáo / Tài sản",
  "KẾ TOÁN / Báo cáo / Dòng tiền",
  "KẾ TOÁN / Công nợ / Phải thu",
  "KẾ TOÁN / Công nợ / Phải trả",
  "KẾ TOÁN / Phiếu thu/chi / Phiếu thu",
  "KẾ TOÁN / Phiếu thu/chi / Phiếu chi",
  "KẾ TOÁN / Sổ chi / Bảng lương",
  "KẾ TOÁN / Sổ chi / Tạm ứng",
  "KẾ TOÁN / Sổ chi / Chi phí trả trước",
  "KẾ TOÁN / Cấu hình / Tài khoản ngân hàng",
  "KẾ TOÁN / Cấu hình / Danh mục thu",
  "KẾ TOÁN / Cấu hình / Danh mục chi",
  "KẾ TOÁN / Cấu hình / Đối tượng chi",
  "KẾ TOÁN / Cấu hình / Đối tượng thu",
  "KẾ TOÁN / Cấu hình / Cấu hình lương",
  "KẾ TOÁN / Dùng tài khoản ngân hàng",
  "CHĂM SÓC KHÁCH HÀNG / conversations",
  "CHĂM SÓC KHÁCH HÀNG / training_ai",
  "CHĂM SÓC KHÁCH HÀNG / multi_channel",
  "CHĂM SÓC KHÁCH HÀNG / setup_ai_staff",
  "THÔNG BÁO / Nhắc nhở đánh giá NCC",
  "THÔNG BÁO / Nhận yêu cầu chuyển đơn",
  "THÔNG BÁO / Được phép thực hiện chuyển đơn",
  "MỞ RỘNG / Bảng giá",
  "MỞ RỘNG / Cài đặt",
];

/** Số user gắn bộ phận từ API (camelCase hoặc snake_case). */
export function getDivisionUserCount(div) {
  if (!div || typeof div !== "object") return 0;
  const raw = div.userCount ?? div.user_count;
  const n = Number(raw);
  return Number.isFinite(n) ? n : 0;
}

/** Tiêu đề / nhãn đầy đủ: «Tên (n)». */
export function formatDivisionLabelWithUserCount(div) {
  if (!div) return "—";
  const name = String(div.name || "—").trim() || "—";
  return `${name} (${getDivisionUserCount(div)})`;
}
